(function() {
    const style = document.createElement('style');
    style.innerHTML = `
        @keyframes premiumGlowPulse {
            0% { box-shadow: 0 0 4px rgba(212, 175, 55, 0.3); }
            50% { box-shadow: 0 0 25px rgba(212, 175, 55, 0.9); }
            100% { box-shadow: 0 0 4px rgba(212, 175, 55, 0.3); }
        }

        .premium-highlight-pulsing {
            /* Solo aplicamos el resplandor y animación, sin tocar bordes */
            animation: premiumGlowPulse 2s infinite ease-in-out !important;
            border-radius: 6px !important; /* Ajuste sutil para que el resplandor siga la forma */
            z-index: 10;
            position: relative;
        }
    `;
    document.head.appendChild(style);

    // Usamos setInterval para asegurar que se aplique incluso si la app recarga el HTML al hacer clic
    setInterval(() => {
        document.querySelectorAll('.bndlr-radio-container:not(.premium-highlight-pulsing)').forEach(container => {
            if (container.textContent && container.textContent.includes('Most Popular')) {
                container.classList.add('premium-highlight-pulsing');
            }
        });
    }, 1000);
})();